<template>
    <b-card no-body>
        
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <brand-model-create-or-update v-model="brandModel" :errors="errors"></brand-model-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="brand-model"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import BrandModelCreateOrUpdate from './components/BrandModelCreateOrUpdate.vue'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'

export default {
    components:{
        BCard,
        BrandModelCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            brandModel:{
                Id:0,
                Name:null,
                VehicleBrandId:0,
            },
            fields:[
                { name:"Marka",key:"VehicleBrandName", thClass:"w-50",sortable:true,sortKey:'VehicleBrand.Name'},
                { name:"Model",key:"Name", thClass:"w-50",sortable:true},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        clearForm(){
            this.editing = false
            this.brandModel.Id = 0
            this.brandModel.Name = null
            this.brandModel.VehicleBrandId = 0
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.brandModel.Id = item.Id
            this.brandModel.Name = item.Name
            this.brandModel.VehicleBrandId = item.VehicleBrandId
            this.$showModal('create-or-update')
        },  
        provider(data){
            return VehicleDefinitionsApi.BrandModel.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            VehicleDefinitionsApi.BrandModel.CreateOrUpdate(this.editing,this.brandModel)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} modelini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleDefinitionsApi.BrandModel.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>